import { createStore } from 'react-hooks-global-state';
import reducer from './Reducer';
import { PageName, PageStatus } from './Actions';
import APP_VERSION from '../observability/appVersion';

export type AppState = {
	online: PageStatus;
	version: string;
	pageName: PageName;
};

const initialState: AppState = {
	online: navigator.onLine ? PageStatus.online : PageStatus.offline,
	version: APP_VERSION,
	pageName: { header: '', subheader: null },
};

export const { dispatch, useGlobalState } = createStore(reducer, initialState);
